import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import './ReactionBar.scss';
import { CommunityContext } from '../../../contexts/ContextCreator';
import CommunityLikeButton from './CommunityLikeButton/CommunityLikeButton';
import CommunityCommentButton from './CommunityCommentButton/CommunityCommentButton';
import CommunityShareButton from './CommunityShareButton/CommunityShareButton';

const ReactionBar = ({
    hash,
    expandCommentCallback,
    location,
    redirectToPage,
    className,
    showLikeLabel,
    showShareLabel,
    onCommentClick,
    snowPlow,
    isCommunityDiscussionType,
}) => {
    const { getContent } = useContext(CommunityContext);
    const content = getContent(hash);
    const isComment = content?.type === 'community-comment';
    const showCommentIcon = isComment ? true : content?.canComment;
    const replyReactionBarStyling = isComment ? 'reply-styling' : '';
    const preloading = content?.preloading;

    const preloadingStyle = preloading ? 'loading-bar' : '';

    return (
        <div
            className={`component-Community-ReactionBar ${replyReactionBarStyling}  ${preloadingStyle} ${className}`}
        >
            {preloading ? (
                <span>
                    <span>&bull;</span>
                    <span>&bull;</span>
                    <span>&bull;</span>
                </span>
            ) : null}
            {!preloading ? (
                <CommunityLikeButton
                    hash={hash}
                    showLabel={showLikeLabel}
                    isCommunityDiscussionType={isCommunityDiscussionType}
                />
            ) : null}
            {showCommentIcon && !preloading ? (
                <CommunityCommentButton
                    hash={hash}
                    expandCommentCallback={expandCommentCallback}
                    location={location}
                    redirectToPage={redirectToPage}
                    onCommentClick={onCommentClick}
                    snowPlow={snowPlow}
                    isCommunityDiscussionType={isCommunityDiscussionType}
                />
            ) : null}
            {!isComment && !preloading ? (
                <CommunityShareButton
                    hash={hash}
                    location={location}
                    showLabel={showShareLabel}
                    snowPlow={snowPlow}
                />
            ) : null}
        </div>
    );
};

ReactionBar.propTypes = {
    hash: PropTypes.string.isRequired,
    /**
     * Function to exapand comment -> should only be used in Commen Components
     */
    expandCommentCallback: PropTypes.func,
    /**
     * component location, mostly needed for the case of contributions.
     */
    location: PropTypes.oneOf([
        'masterFeed',
        'miniFeed',
        'groupFeed',
        'singleContent',
        'contributions',
        'homePage',
    ]),
    redirectToPage: PropTypes.bool,
    /**
     * Optional styles for this component
     */
    className: PropTypes.string,
    /**
     * Show label on Like button
     */
    showLikeLabel: PropTypes.bool,
    /**
     * Show label on Share button
     */
    showShareLabel: PropTypes.bool,
    onCommentClick: PropTypes.func,
    snowPlow: {
        component: PropTypes.string,
        componentTitleType: PropTypes.string,
        position: PropTypes.string,
        pageType: PropTypes.string,
        targetPageSection: PropTypes.string,
        pageSection: PropTypes.string,
        companyId: PropTypes.string,
        tileEntityId: PropTypes.string,
        tileType: PropTypes.string,
        tileOrder: PropTypes.number,
    },
    isCommunityDiscussionType: PropTypes.bool,
};

ReactionBar.defaultProps = {
    expandCommentCallback: null,
    location: 'masterFeed',
    redirectToPage: false,
    className: '',
    showLikeLabel: true,
    showShareLabel: true,
    onCommentClick: null,
    snowPlow: null,
    isCommunityDiscussionType: false,
};

ReactionBar.displayName = 'ReactionBar';

export default React.memo(ReactionBar);
